import configuration from './configuration';

const mixpanel = require('mixpanel-browser');

const mixpanelActions = {
  // To initialize the mix-panel track
  init: id => {
    mixpanel.init(id);
  },
  // To identify each track belongs to which user
  identify: id => {
    mixpanel.identify(id);
  },
  // To track the actions / events belongs to different users
  track: (name, ...props) => {
    mixpanel.track(name, ...props);
  },
  // resetting mix-panel config while logging out
  reset: () => mixpanel.reset(),
  // can get the UNIQUE ID that has been assigned to the individual user
  getDistinctID: () => mixpanel.get_distinct_id(),
};

const mockMixpanelActions = {
  init: () => undefined,
  // To identify each track belongs to which user
  identify: () => undefined,
  // To track the actions / events belongs to different users
  track: () => undefined,
  // resetting mix-panel config while logging out
  reset: () => undefined,
  // can get the UNIQUE ID that has been assigned to the individual user
  getDistinctID: () => undefined,
};

const Mixpanel = configuration.MIX_PANEL_TOKEN
  ? mixpanelActions
  : mockMixpanelActions;


const trackStrings = {

  VISITED_APP_SCREEN: 'VISITED_APP_SCREEN',
  DEFAULTDATA_APP_SCREEN: 'DEFAULTDATA_APP_SCREEN',
  
  VISITED_REGISTER_SCREEN: 'VISITED_REGISTER_SCREEN',
  REGISTER_SCREEN_LOADED: 'REGISTER_SCREEN_LOADED',
  REGISTER_SCREEN_ANCHOR_CREDIT_ISSUE: 'REGISTER_SCREEN_ANCHOR_CREDIT_ISSUE',
  REGISTER_SCREEN_OTP_ERROR: 'REGISTER_SCREEN_OTP_ERROR',
  REGISTER_SCREEN_AUTH_LIST_SUCCESS: 'REGISTER_SCREEN_AUTH_LIST_SUCCESS',
  REGISTER_SCREEN_AUTH_LIST_ERROR: 'REGISTER_SCREEN_AUTH_LIST_ERROR',
  REGISTER_SCREEN_AUTH_ERROR: 'REGISTER_SCREEN_AUTH_ERROR',
  REGISTER_SCREEN_CREATE_BORROWER_SUCCESS: 'REGISTER_SCREEN_CREATE_BORROWER_SUCCESS',
  REGISTER_SCREEN_OTP_SUCCESS: 'REGISTER_SCREEN_OTP_SUCCESS',
  REGISTER_SCREEN_CREATE_BORROWER_ERROR: 'REGISTER_SCREEN_CREATE_BORROWER_ERROR',


  VISITED_DIRECTOR_SCREEN: 'VISITED_DIRECTOR_SCREEN',
  DIRECTOR_SCREEN_UPDATE_BORROWER_SUCCESS: 'DIRECTOR_SCREEN_UPDATE_BORROWER_SUCCESS',
  DIRECTOR_SCREEN_UPDATE_BORROWER_ERROR: 'DIRECTOR_SCREEN_UPDATE_BORROWER_ERROR',

  VISITED_OFFER_SCREEN: 'VISITED_OFFER_SCREEN',
  OFFER_SCREEN_OFFER_SUCCESS: 'OFFER_SCREEN_OFFER_SUCCESS',
  OFFER_SCREEN_OFFER_EMPTY: 'OFFER_SCREEN_OFFER_EMPTY',
  OFFER_SCREEN_OFFER_ERROR: 'OFFER_SCREEN_OFFER_ERROR',
  OFFER_SCREEN_OFFER_RETRY: 'OFFER_SCREEN_OFFER_RETRY',
  OFFER_SCREEN_OFFER_SET_SUCCESS: 'OFFER_SCREEN_OFFER_SET_SUCCESS',
  OFFER_SCREEN_OFFER_SET_ERROR: 'OFFER_SCREEN_OFFER_SET_ERROR',

  VISITED_DOCUMENT_SCREEN: 'VISITED_DOCUMENT_SCREEN',
  DOCUMENT_SCREEN_LIST_SUCCESS: 'DOCUMENT_SCREEN_LIST_SUCCESS',
  DOCUMENT_SCREEN_LIST_ERROR: 'DOCUMENT_SCREEN_LIST_ERROR',
  DOCUMENT_SCREEN_UPLOAD_SUCCESS: 'DOCUMENT_SCREEN_UPLOAD_SUCCESS',
  DOCUMENT_SCREEN_UPLOAD_ERROR: 'DOCUMENT_SCREEN_UPLOAD_ERROR',

  VISITED_BANK_ACCOUNT_SCREEN: 'VISITED_BANK_ACCOUNT_SCREEN',
  BANK_ACCOUNT_SCREEN_IFSC_SUCCESS:'BANK_ACCOUNT_SCREEN_IFSC_SUCCESS',
  BANK_ACCOUNT_SCREEN_IFSC_ERROR: 'BANK_ACCOUNT_SCREEN_IFSC_ERROR',
  BANK_ACCOUNT_SCREEN_ACC_SUCCESS: 'BANK_ACCOUNT_SCREEN_ACC_SUCCESS',
  BANK_ACCOUNT_SCREEN_ACC_ERROR: 'BANK_ACCOUNT_SCREEN_ACC_ERROR',
  BANK_ACCOUNT_SCREEN_ACC_ADD_SUCCESS: 'BANK_ACCOUNT_SCREEN_ACC_ADD_SUCCESS',
  BANK_ACCOUNT_SCREEN_ACC_ADD_ERROR: 'BANK_ACCOUNT_SCREEN_ACC_ADD_ERROR',

  VISITED_ESIGN_SCREEN: 'VISITED_ESIGN_SCREEN',
  ESIGN_SCREEN_INIT_SUCCESS: 'ESIGN_SCREEN_INIT_SUCCESS',
  ESIGN_SCREEN_INIT_ERROR: 'ESIGN_SCREEN_INIT_ERROR',
  ESIGN_SCREEN_PLUGIN: 'ESIGN_SCREEN_PLUGIN',
  ESIGN_SCREEN_PLUGIN_CALLBACK: 'ESIGN_SCREEN_PLUGIN_CALLBACK',
  ESIGN_SCREEN_DOCUMENT_LIST_SUCCESS: 'ESIGN_SCREEN_DOCUMENT_LIST_SUCCESS',
  ESIGN_SCREEN_DOCUMENT_LIST_ERROR:'ESIGN_SCREEN_DOCUMENT_LIST_ERROR',
  ESIGN_SCREEN_EMAIL_DATA_SUCCESS:'ESIGN_SCREEN_EMAIL_DATA_SUCCESS',
  ESIGN_SCREEN_EMAIL_DATA_ERROR:'ESIGN_SCREEN_EMAIL_DATA_ERROR',
  ESIGN_SCREEN_EMAIL_DATA_REQUEST:'ESIGN_SCREEN_EMAIL_DATA_REQUEST',
  VISITED_ESIGN_SCREEN_EMAIL:'VISITED_ESIGN_SCREEN_EMAIL',

  VISITED_EMANDATE_SCREEN: 'VISITED_EMANDATE_SCREEN',
  EMANDATE_SCREEN_LIST_SUCCESS: 'EMANDATE_SCREEN_LIST_SUCCESS',
  EMANDATE_SCREEN_LIST_ERROR: 'EMANDATE_SCREEN_LIST_ERROR',
  EMANDATE_SCREEN_INIT_SUCCESS: 'EMANDATE_SCREEN_INIT_SUCCESS',
  EMANDATE_SCREEN_INIT_ERROR: 'EMANDATE_SCREEN_INIT_ERROR',
  EMANDATE_SCREEN_PLUGIN: 'EMANDATE_SCREEN_PLUGIN',
  EMANDATE_SCREEN_PLUGIN_CALLBACK: 'EMANDATE_SCREEN_PLUGIN_CALLBACK',
  EMANDATE_SCREEN_PHY_SUCCESS: 'EMANDATE_SCREEN_PHY_SUCCESS',
  EMANDATE_SCREEN_PHY_ERROR: 'EMANDATE_SCREEN_PHY_ERROR',
  EMANDATE_SCREEN_DOC_OK: 'EMANDATE_SCREEN_DOC_OK',
  EMANDATE_SCREEN_DOC_ERROR: 'EMANDATE_SCREEN_DOC_ERROR',
  EMANDATE_SCREEN_SET_STEP_SUCCESS: 'EMANDATE_SCREEN_SET_STEP_SUCCESS',
  EMANDATE_SCREEN_SET_STEP_ERROR: 'EMANDATE_SCREEN_SET_STEP_ERROR',
  VISITED_EMANDATE_PHY_SCREEN: 'VISITED_EMANDATE_PHY_SCREEN',
  VISITED_EMANDATE_PHY_UPLOAD_SCREEN: 'VISITED_EMANDATE_PHY_UPLOAD_SCREEN',
  VISITED_EMANDATE_PHY_UPLOAD_NEXT_SCREEN: 'VISITED_EMANDATE_PHY_UPLOAD_NEXT_SCREEN',

  VISITED_EMANDATE_SUCCESS_SCREEN: 'VISITED_EMANDATE_SUCCESS_SCREEN',

  VISITED_SUCCESS_SCREEN: 'VISITED_SUCCESS_SCREEN',
  

  API_ERROR: 'API_ERROR', // Tracked
};

export { Mixpanel, trackStrings };
